'use strict';

$.widget('agito.globalnavigation', {
    root: null,
    megamenu: null,
    prelevel: null,
    firstlevel: null,
    secondlevel: null,
    navigationbar: null,
    levels: [],
    // offset left can be wrong during resizes...since it's always the same we'll store it here
    leftPartOffset: 0,
    breadCrumbMinimumWidth: 50,
    breadCrumb: null,
    isOpened: false,

    _create: function () {

        let _this = this;
        
        requestAnimationFrame(function () {

            // small TODO modify the logic to work independent from level

            _this.root = $('.globalnavigation-root');
            _this.navigationbar = _this.root.find('.globalnavigation-navigationbar');
            _this.megamenu = _this.root.find('.globalnavigation-megamenu');
            _this.firstlevel = _this.megamenu.find('.globalnavigation-megamenu-firstlevel');
            _this.secondlevel = _this.megamenu.find('.globalnavigation-megamenu-secondlevel');

            // hide everything while we apply the form of the navigation
            _this.root.hide();
            _this.secondlevel.find('ul').hide();
            _this.megamenu.hide();

            // add neccessary classes
            _this.navigationbar.addClass('nav navbar-nav');
            _this.megamenu.addClass('dropdown-menu');
            _this.firstlevel.addClass('globalnavigation-megamenu-levels');
            _this.secondlevel.addClass('globalnavigation-megamenu-levels');
            _this.firstlevel.find('li').addClass('globalnavigation-megamenu-megamenuitem globalnavigation-megamenu-megamenuitemfirstlevel');
            _this.secondlevel.find('li').addClass('globalnavigation-megamenu-megamenuitem');

            // insert a div to force space when selecting the first level from navigationbar
            _this.megamenu.prepend('<div class="shadow globalnavigation-megamenu-levels globalnavigation-megamenu-megaMenuItemPreLevel"></div>');
            _this.prelevel = _this.megamenu.find('div.globalnavigation-megamenu-megaMenuItemPreLevel');

            // get array of levels for easier access
            _this.levels[0] = _this.prelevel;
            _this.levels[1] = _this.firstlevel;
            _this.levels[2] = _this.secondlevel;

            // add neccessary elements
            // links in the navigation bar get a down glyphicon
            _this.navigationbar.find('li > a').after('<span class="glyphicon glyphicon-menu-down globalnavigation-glyphicon globalnavigation-navigationbar-glyphicondown"></span>');
            // spans in the megamenu get a right glyphicon
            _this.firstlevel.find('li.globalnavigation-megamenu-megamenuitem > span:first-child').after('<span class="globalnavigation-glyphicon-rightouterwrapper"><span class="globalnavigation-flexcenter globalnavigation-glyphicon-rightinnerwrapper"><span class="glyphicon glyphicon-menu-right globalnavigation-flexcenter globalnavigation-glyphicon globalnavigation-glyphicon-right"></span></span></span>');
            _this.secondlevel.find('li.globalnavigation-megamenu-megamenuitem > span:first-child').after('<span class="globalnavigation-glyphicon-rightouterwrapper"><span class="globalnavigation-flexcenter globalnavigation-glyphicon-rightinnerwrapper"><span class="glyphicon glyphicon-menu-right globalnavigation-flexcenter globalnavigation-glyphicon globalnavigation-glyphicon-right"></span></span></span>');
            // links in the megamenu don't get a right glyphicon, just an empty box
            _this.firstlevel.find('li.globalnavigation-megamenu-megamenuitem > a:first-child').after('<span class="globalnavigation-glyphicon-rightouterwrapper"><span class="globalnavigation-flexcenter globalnavigation-glyphicon-rightinnerwrapper"></span></span>');
            _this.secondlevel.find('li.globalnavigation-megamenu-megamenuitem > a:first-child').after('<span class="globalnavigation-glyphicon-rightouterwrapper"><span class="globalnavigation-flexcenter globalnavigation-glyphicon-rightinnerwrapper"></span></span>');
            // wrapping it for form
            _this.navigationbar.find('li').wrapInner('<a class="globalnavigation-navigationbar-menuitemwrapper"></a>');
            _this.firstlevel.find('li.globalnavigation-megamenu-megamenuitem > span:first-child').wrapInner('<span class="globalnavigation-flexcenter"></span>');
            _this.secondlevel.find('li.globalnavigation-megamenu-megamenuitem > span:first-child').wrapInner('<span class="globalnavigation-flexcenter"></span>');
            _this.firstlevel.find('li.globalnavigation-megamenu-megamenuitem').wrap('<div class="globalnavigation-megamenu-megamenuitemcontainer globalnavigation-megamenu-megamenuitemcontainerlarge"></div>');
            _this.secondlevel.find('li.globalnavigation-megamenu-megamenuitem').wrap('<div class="globalnavigation-megamenu-megamenuitemcontainer globalnavigation-megamenu-megamenuitemcontainersmall"></div>');
            _this.firstlevel.find('ul').wrap('<div class="globalnavigation-widthhundred"></div>');
            _this.secondlevel.find('ul').wrap('<div></div>');
            _this.secondlevel.wrapInner('<div class="globalnavigation-widthhundred"></div>');

            // display everything again after we're done applying the form
            _this.root.show();
            
            // megamenu hiding if you click outside
            _this._on(document, {
                mouseup: function (event) {
                    
                    if (_this.isOpened && !_this.root.is(event.target) // if the target of the click isn't the container...
                        && _this.root.has(event.target).length === 0 // ... nor a descendant of the container
                    ) {
                        requestAnimationFrame(function() {
                            _this._hideMegaMenu(_this);
                        });
                    }
                }
            });

            // opening megamenu from breadcrumb
            for (var i = 0; i < _this.levels.length - 1; i++) {
                _this._on(_this.levels[i].find('li.globalnavigation-megamenu-megamenuitem'), {
                    click: function (event) {
                        requestAnimationFrame(function() {
                            // when clicking on an item in the megamenu that opens a new set of items on the lower level
                            var target = $(event.currentTarget);
                            var level = target.closest('div.globalnavigation-megamenu-levels').data('globalnavigation-level');
                            _this._switchnavigation(_this, level, target);
                        });
                    }
                });
            }
            
            _this._on(_this.navigationbar.find('span.glyphicon'), {
                click: function (event) {
                    requestAnimationFrame(function() {

                        //close other dialogs
                        $('.navbar-nav > li.open').removeClass('open');

                        var target = $(event.currentTarget).closest('li');
                        if (target.hasClass('active')) {
                            // if you click on the same item in the navigation bar again, close the megamenu
                            _this._hideMegaMenu(_this);
                        }
                        else {
                            event.stopPropagation();
                            var parentId = target.data('parent-id');
                            var level = target.data('globalnavigation-level');

                            _this._removeClassAll(_this, 'ul.globalnavigation-megamenu-itemexpanded', 'globalnavigation-megamenu-itemexpanded');
                            _this._removeClassAll(_this, null, 'globalnavigation-megamenu-itemexpanded');

                            _this.megamenu.show();
                            _this.navigationbar.find('li').removeClass('active');
                            // always set the mobile version to active
                            _this.navigationbar.find('li.hamburgerButtonContainer').addClass('active');
                            // if the mobile was clicked also set to active the first level of the ordinary one
                            if (target.hasClass('hamburgerButtonContainer')) {
                                _this.navigationbar.find('li[data-globalnavigation-level="1"]').addClass('active');
                            }
                            target.addClass('active');
                            _this.secondlevel.find('ul').hide();
                            _this.secondlevel.find('ul[data-parent-id=' + parentId + ']').show();
                            
                            _this.firstlevel.find('li').removeClass('selected');
                            _this.firstlevel.find('div.globalnavigation-megamenu-megamenuitemcontainer').removeClass('selected');
                            _this.firstlevel.find('li[data-navigation-id=' + parentId + ']').addClass('selected');
                            _this.firstlevel.find('li[data-navigation-id=' + parentId + ']').closest('.globalnavigation-megamenu-megamenuitemcontainer').addClass('selected');

                            // reset previously set class and flex-basis
                            _this._setCssAll(_this, null, 'flex-basis', 'auto');
                            _this._removeClassAll(_this, null, 'globalnavigation-flexstatic');
                            _this._removeClassAll(_this, null, 'globalnavigation-megamenu-disabled');

                            _this.levels[level - 1].addClass('globalnavigation-flexstatic globalnavigation-megamenu-disabled');
                            var leftOffset = target.offset().left;
                            _this.levels[level - 1].css('flex-basis', leftOffset + 1);
                            _this.levels[level - 1].find('ul').addClass('globalnavigation-megamenu-itemexpanded');
                            _this.levels[level - 1].addClass('globalnavigation-megamenu-itemexpanded');

                            _this.isOpened = true;
                        }
                    });
                }
            });
        });
    },

    _hideMegaMenu: function (_this) {
        _this.navigationbar.find('li').removeClass('active');
        _this._removeClassAll(_this, 'ul.globalnavigation-megamenu-itemexpanded', 'globalnavigation-megamenu-itemexpanded');
        _this._removeClassAll(_this, null, 'globalnavigation-megamenu-itemexpanded');
        _this.megamenu.hide();

        _this.isOpened = false;
    },
    
    _switchnavigation: function (_this, currentlevel, target) {
        
        // if you clicked the same one again, unselect it
        if (target.hasClass('selected')
            && !(target.closest('div.globalnavigation-megamenu-levels').hasClass('globalnavigation-megamenu-disabled')
                && _this.levels[currentlevel].find('.globalnavigation-megamenu-headertext').is(':visible'))) {
            _this.levels[currentlevel].find('li').removeClass('selected');
            _this.levels[currentlevel].find('.globalnavigation-megamenu-megamenuitemcontainer').removeClass('selected');
            _this.levels[currentlevel].find('ul').removeClass('globalnavigation-megamenu-itemexpanded');
            _this.levels[currentlevel].removeClass('globalnavigation-megamenu-itemexpanded');
            _this.levels[currentlevel + 1].find('ul').hide();

            _this.isOpened = false;
            
            // if you are have opened non-mobile megamenu level n + 1 -> mobile -> clicked level n -> non-mobile
            // you would get a level n + 1 megamenu with an empty n + 1 level menu
            // in this case we reset the non mobile portion to level n
            if (target.closest('div.globalnavigation-megamenu-levels').hasClass('globalnavigation-megamenu-disabled')
                && !_this.levels[currentlevel].find('.globalnavigation-megamenu-headertext').is(':visible')) {

                _this._setCssAll(_this, null, 'flex-basis', 'auto');
                _this._removeClassAll(_this, null, 'globalnavigation-flexstatic');
                _this._removeClassAll(_this, null, 'globalnavigation-megamenu-disabled');

                this.levels[currentlevel - 1].addClass('globalnavigation-flexstatic globalnavigation-megamenu-disabled');
                var leftOffset = _this.navigationbar.find('li[data-globalnavigation-level="' + currentlevel + '"]').offset().left;
                _this.levels[currentlevel - 1].css('flex-basis', leftOffset + 1);
                _this.levels[currentlevel - 1].find('ul').addClass('globalnavigation-megamenu-itemexpanded');
                _this.levels[currentlevel - 1].addClass('globalnavigation-megamenu-itemexpanded');

                _this.navigationbar.find('li').removeClass('active');
                _this.navigationbar.find('li.hamburgerButtonContainer').addClass('active');
                _this.navigationbar.find('li[data-globalnavigation-level="' + currentlevel + '"]').addClass('active');

                _this.isOpened = true;
            }
        }
        else {
            _this.levels[currentlevel].find('li').removeClass('selected');
            _this.levels[currentlevel].find('.globalnavigation-megamenu-megamenuitemcontainer').removeClass('selected');
            _this.levels[currentlevel].find('ul').addClass('globalnavigation-megamenu-itemexpanded');
            _this.levels[currentlevel].addClass('globalnavigation-megamenu-itemexpanded');
            target.addClass('selected');
            target.closest('.globalnavigation-megamenu-megamenuitemcontainer').addClass('selected');
            var parentId = target.data('navigation-id');
            _this.levels[currentlevel + 1].find('ul').hide();
            
            _this.levels[currentlevel + 1].find('ul[data-parent-id="' + parentId + '"]').slideDown("fast");

            _this.isOpened = true;
        }
    },
    
    _removeClassAll: function (_this, element, className) {
        if (element == null) {
            for (var i = 0; i < _this.levels.length; i++) {
                _this.levels[i].removeClass(className);
            }
        }
        else {
            for (var i = 0; i < _this.levels.length; i++) {
                _this.levels[i].find(element).removeClass(className);
            }
        }
    },

    _setCssAll: function (_this, element, css, value) {
        if (element == null) {
            for (var i = 0; i < _this.levels.length; i++) {
                _this.levels[i].css(css, value);
            }
        }
        else {
            for (var i = 0; i < _this.levels.length; i++) {
                _this.levels[i].find(element).css(css, value);
            }
        }
    }
});